

export const keys = {
    all: ["admin-reports"],
    
    alarmNotificationsAdminReport: (
        contextGroupID: number,
        stateDate: Date | undefined,
        endDate: Date | undefined
        ) => [
            ...keys.all,
            "alarm-notification-report", {
                contextGroupID,
                stateDate,
                endDate
            }
        ],

    alarmSetpointReport: (
        organizationID: number,
        contextGroupID: number,
        includeInActiveAndInvisibleDevices: boolean
        ) => [
            ...keys.all,
            "alarm-setpoint-report", {
                organizationID,
                contextGroupID,
                includeInActiveAndInvisibleDevices
            }
        ],        

    badCommsReport: (
        contextGroupID: number,
        startDate: Date,
        endDate: Date

        ) => [
            ...keys.all,
            "bad-comms-report", {
                contextGroupID,
                startDate,
                endDate

            }
        ],        
    disabledRecipientsReport: (
        contextGroupID: number,
        startDate: Date,
        endDate: Date
        ) => [
            ...keys.all,
            "disabled-recipients-report", {
                contextGroupID,
                startDate,
                endDate
            }
        ],        
    availableRecipientsToNotifyForUser: (
        contextGroupID: number,
        ) => [
            ...keys.all,
            "available-recipients-to-notify-for-user", {
                contextGroupID,
            }
        ],        
            
};

